// Vuex
import store from '@/store.js';

import Request from './request';

async function login(data) {
    const response = await Request('post', "api/authorizations", data);
    if (response.data && response.data.status.isOK()) {
        store.commit("LOGIN", response.data.access_token);
        store.commit("USERTYPE", response.data.user_type)
    }else if (response.data.status == 'NG') {
        store.commit("LOGOUT", false); // 前端登出
    }
    return response;
}

async function accountPasswordForShops(data) {
    return await Request('post', "api/authorizations/account-password-for-shops", data);
}

async function check() {// 检查本地accessToken的登录状态
    const response = await Request('get', "api/authorizations");
    if (response.data && response.data.status.isOK()) {
        store.commit("LOGIN", localStorage.getItem("accessToken"));
        store.commit("USERTYPE", localStorage.getItem("userType"));
    } else {
        store.commit("LOGOUT"); // 前端登出
    }
    return response;
}

async function logout() {
    store.commit("LOGOUT"); // 前端登出
    return Request('delete', "api/authorizations/0"); // 后端登出（调用cake的delete方法一定要给id参数）
}

export default {
    login,
    accountPasswordForShops,
    check,
    logout
};